import { Schema } from 'effect';
import { Location2DSchema } from './location';

export const LaunchpadIdSchema = Schema.Number;
export type LaunchpadId = Schema.Schema.Type<typeof LaunchpadIdSchema>;

export const LaunchpadSchema = Schema.Struct({
  id: LaunchpadIdSchema,
  letter: Schema.String,
  color: Schema.String,
  location: Location2DSchema
});
export type Launchpad = Schema.Schema.Type<typeof LaunchpadSchema>;
